import { FunctionComponent, useState } from "react";
import styles from "./PublishPopupSingle.module.css";
import {
  CustomTextField,
  InputPropsStyleForInvoice,
  checking,
  manageticketsrowType,
  splitLocation,
} from "../../../helper";
import { Button, InputAdornment } from "@mui/material";
import { useForm } from "react-hook-form";
import images from "../../../assets/images/index";

interface PublishPopupSingleProps {
  row: manageticketsrowType;
  handleCloseDialog: () => void;
  handleAllow: any;
}

const InputField = CustomTextField();

const PublishPopupSingle: FunctionComponent<PublishPopupSingleProps> = ({
  row,
  handleCloseDialog,
  handleAllow,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: { listPrice: "" },
    mode: "onTouched",
  });
  const [listprice, setListPrice] = useState<string>("");
  const [errorForZero, setErrorForZero] = useState<string>("");
  const [showIcon, setShowIcon] = useState(false);

  const { CloseIcon } = images;


  const handleSubmitListPrice = (formData: { listPrice: string }) => {
    const regex=/^(?!\.).*(?<!\.)$/;
    if (
      parseFloat(formData?.listPrice) <= 0
    ) {
      setErrorForZero("Price should be greater than zero");
    }else if(regex.test(formData?.listPrice)){
      handleAllow(listprice);
    }else {
      setError('listPrice',{
        type: 'manual',
        message: "Enter a valid List Price",
      })
    }
  };

  const handleResetListprice = () =>{
    reset()
    setListPrice("")
  }

  const handleChangeListPrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setErrorForZero("");
    const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    if (regexPattern.test(input)) {
      if (parseFloat(input) <= 100000 && parseFloat(input) >= 0) {
        setValue("listPrice", input);
        setListPrice(input);
        trigger("listPrice");
      }
    } else {
      setListPrice(listprice);
    }
  };

  const handleFocus = () => {
    setShowIcon(true);
  };

  const handleKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(listprice.length === 1){
        setListPrice("")
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(handleSubmitListPrice)} autoComplete="off">
      <div className={styles.markAsSold}>
        <div className={styles.title}>
          <b className={styles.markAsSoldTitle}>Publish Ticket</b>
          <div className={styles.closeicon}>
            <img src={CloseIcon} alt="closeicon" onClick={handleCloseDialog} />
          </div>
        </div>
        <div className={styles.eventDetailsAndLogitixSoldpublish}>
          <div className={styles.eventDetailspublish}>
            <div className={styles.eventDetails1publish}>Event Details</div>
            <div className={styles.eventDetails2publish}>
              <div className={styles.eventpublish}>
                <b className={styles.date}>Event</b>
                <b className={styles.rocketsVsMemphispublish}>{row?.e_name}</b>
              </div>
              <div className={styles.eventpublish}>
                <b className={styles.date}>Date</b>
                <b className={styles.rocketsVsMemphispublish}>
                  {checking(row?.e_date).date} /&nbsp;
                  {checking(row?.e_date).time}
                </b>
              </div>
              <div className={styles.eventpublish}>
                <b className={styles.date}>Venue</b>
                <b className={styles.rocketsVsMemphispublish}>
                  {splitLocation(row?.e_address).firstWord}
                  {splitLocation(row?.e_address).remainingWords}
                </b>
              </div>
              <div className={styles.eventpublish}>
                <b className={styles.date}>Ticket Placement</b>
                <b className={styles.secA}>
                  Sec : {row?.tp_section} / Row : {row?.tp_row} / Seat : {row?.tp_seat_no}
                </b>
              </div>
            </div>
          </div>
          <div className={styles.logitixSoldPrice}>
            <div className={styles.eventDetails1publish}>List Price</div>
            <div className={styles.bg}>
              <div className={styles.eventDetailspublish}>
                <div className={styles.soldPrice}>
                <div className={styles.transactionId}>
                  <b className={styles.date}>Enter amount</b>
                  <span className={styles.errorMsgStyle}>
                        { errorForZero  || errors?.listPrice?.message}
                  </span>
                </div>
                  <div className={styles.textField}>
                    <div className={styles.container}>
                      <InputField
                        sx={{
                          "& input": {
                            height: "0.0375em",
                          },
                        }}
                        classes={{
                          root: styles.amountdiv,
                        }}
                        {...register("listPrice", {
                          required: "List price is required!",
                        })}
                        value={listprice}
                        InputProps={{
                          style: InputPropsStyleForInvoice,
                          startAdornment: (
                            <InputAdornment position="start">
                              {showIcon && `$`}
                            </InputAdornment>
                          ),
                        }}
                        placeholder={watch('listPrice') ? "" : `Eg,. $121.00`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeListPrice(e)}
                        error={Boolean(errors?.listPrice?.message)}
                        onFocus={handleFocus}
                        onKeyDown={handleKeyDown}
                      />
                    </div>
                  </div>
                </div>
             
                
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cta}>
          <div className={styles.buttons} onClick={handleResetListprice}>
            <Button
              classes={{ root: styles.separateStyleforcancel }}
              fullWidth
              disableRipple
            >
              Reset
            </Button>
          </div>
          <div className={styles.buttons1}>
            <Button
              classes={{ root: styles.separateStyle }}
              disableRipple
              fullWidth
              type="submit"
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PublishPopupSingle;
